import React from 'react';
import { connect } from 'react-redux';
import { setMessageInput } from '../../actions';
import Tooltip from '../../../../controls/tooltip';

class TextArea extends React.Component {
    constructor(props) {
        super(props);

        this.control = null;
        this.shadowControl = null;
        this.keypressTimeout = null;
        this.onKeyDown = this.onKeyDown.bind(this);
        this.resizeTextarea = this.resizeTextarea.bind(this);
        this.appendText = this.appendText.bind(this);

        if (this.props.callbacks) {
            this.props.callbacks({
                textArea: this,
                appendText: this.appendText
            });
        }
    }

    componentDidMount() {
        if (this.props.autosize) {
            this.keypressTimeout = setTimeout(this.resizeTextarea, 10);
        }
    }

    componentWillUnmount() {
        if (this.keypressTimeout) clearTimeout(this.keypressTimeout);
        this.keypressTimeout = null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps) {
            if (this.keypressTimeout) clearTimeout(this.keypressTimeout);
            this.keypressTimeout = setTimeout(this.resizeTextarea, 10);
        }
    }

    resizeTextarea() {
        if (!this.props.autosize) return;

        const rel = this.control;
        const el = this.shadowControl;

        // make calculations on shadow control to avoid on screen flickering (visible on FireFox)
        const defaultCss = `width: ${rel.offsetWidth}px !important; line-height: 20px; position: fixed; left: 0px; top: 0px; visibility: hidden;`;

        let css = window.getComputedStyle(el, null);
        const lineHeight = parseInt(css.lineHeight);

        el.style.cssText = `height: auto;  ${defaultCss}`;
        css = window.getComputedStyle(el, null);
        const height = parseInt(el.scrollHeight);
        const paddingTop = parseInt(css.paddingTop);
        const paddingBottom = parseInt(css.paddingBottom);
        let textHeight = height - paddingTop - paddingBottom;
        if (textHeight > lineHeight && textHeight < 2 * lineHeight)
            // FF fix for one line textarea calculating wrong height
            textHeight = lineHeight;
        const maxHeight = this.props.maxRows * lineHeight + paddingTop + paddingBottom + 2;
        const newHeight = Math.max(
            Math.min(textHeight + paddingTop + paddingBottom + 2, maxHeight),
            lineHeight + paddingTop + paddingBottom + 2
        );
        el.style.cssText = `height: ${newHeight}px; ${defaultCss}`;

        // copy from shadow to real control
        rel.style.cssText = `height: ${newHeight}px; line-height: 20px;`;
    }

    onKeyDown(event) {
        if (event.keyCode === 13 && !event.shiftKey && this.props.onSubmit) {
            event.preventDefault();
            if (this.props.value.length > 0) {
                this.props.onSubmit(event);
            }
            return;
        }
        const allowKeys = [8, 46, 16, 18, 37, 38, 39, 40];
        if (allowKeys.indexOf(event.keyCode) >= 0) {
            // dopuść, shift, kursory, delete, backspace
            this.tooltip.hide();
            return;
        }
        const summaryLen = this.props.currentLength;
        const totalLen = this.props.value.length + summaryLen;
        if (this.props.maxLength !== null && totalLen >= this.props.maxLength) {
            this.tooltip.show();
            event.preventDefault();
            return;
        }
        this.tooltip.hide();
    }

    appendText(text) {
        const start = this.control.selectionStart;
        const end = this.control.selectionEnd;
        this.shadowControl.value = this.control.value =
            this.control.value.substring(0, start) + text + this.control.value.substring(end);

        const { dispatch } = this.props;
        dispatch(setMessageInput(this.control.value));
        this.control.selectionStart = start + text.length;
        this.control.selectionEnd = start + text.length;
        this.control.focus();
    }

    render() {
        return (
            <div>
                {this.props.autosize && (
                    <textarea
                        ref={(el) => (this.shadowControl = el)}
                        className={this.props.className}
                        /* style={ {...this.props.style, position: 'fixed', left: '0px', height: 'auto'} } */
                        value={this.props.value}
                        placeholder={this.props.placeholder}
                        rows={this.props.rows}
                        readOnly
                    />
                )}
                <textarea
                    ref={(el) => (this.control = el)}
                    className={this.props.className}
                    style={this.props.style}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    rows={this.props.rows}
                    required={this.props.required}
                    disabled={this.props.disabled}
                    onChange={this.props.onChange}
                    onKeyDown={this.onKeyDown}
                    maxLength={this.props.maxLength}
                    data-tip="chat-limit-tooltip"
                    data-tiptext="Twoja wiadomość jest już maksymalnej długości. Zaczekaj proszę na odpowiedź."
                />
                <Tooltip
                    ref={(el) => (this.tooltip = el)}
                    id="chat-limit-tooltip"
                    className="theme-dark"
                    trigger="manual"
                    align="center"
                    anchor="above"
                    hideDelay={3000}
                />
            </div>
        );
    }
}

TextArea.defaultProps = {
    maxRows: 0,
    value: '',
    placeholder: '',
    required: false,
    disabled: false
};

const mapStateToProps = (state) => {
    return {
        messageInput: state.chat.messageInput || ''
    };
};

export default connect(mapStateToProps)(TextArea);
